import * as React from 'react';
import { observer } from 'mobx-react-lite';

const styles = require('./EmptySpacer.scss');
const classNames = require('classnames/bind').bind(styles);

const EmptySpacer = observer(function EmptySpacer(props: {}) {
    return <div className={classNames(styles.emptySpacer)} />;
});
export default EmptySpacer;
